import React, { useEffect, useState } from 'react';
import GpsPings from '../../../../common/GpsPings';

const GpsPingsManager = ({ gpsManagerData, DispatchStore, userData, theme, routeData }) => {
  const [gpsDriverRoute, setGpsDriverRoute] = useState(null);

  const getGpsRouteData = (driverId) => {
    const selectedRouteData = routeData?.find(
      (route) => route.driverId.toLowerCase() === driverId.toLowerCase()
    );
    const dataSource = selectedRouteData ?? DispatchStore.getCurrentDriver(driverId);
    if (dataSource) {
      return {
        dispatchDateTime: `${dataSource.driverDispatchTime}`,
        dispatchId: dataSource.dispatchId,
        driverId: dataSource.driverId,
        isLiveDispatch: true,
        terminal: { terminalCode: userData.userProfile.terminal.code },
        routeStartTime: dataSource.routeStartTime,
        routeEndTime: dataSource.routeEndTime,
        routeId: dataSource.routeId
      };
    }
    return null;
  };

  useEffect(() => {
    if (gpsManagerData?.driverId) {
      const gpsRouteData = getGpsRouteData(gpsManagerData.driverId);
      setGpsDriverRoute(gpsRouteData);
    }
  }, [gpsManagerData?.driverId, routeData]);

  return (
    gpsManagerData && (
      <GpsPings
        theme={theme}
        route={gpsDriverRoute}
        isMultiRoute
        showActualRoute={gpsManagerData?.showActualRoute}
      />
    )
  );
};

export default GpsPingsManager;
